import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/subtypes/repair/todo_templates/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = `/settings/subtypes/repair/todo_templates`;

const Home: NextPage = () => (
  <>
    <NskHead title="TODOテンプレート" />
    <Component />
  </>
);

export default Home;
